import {
    Pagination as CustomPagination,
    Select,
} from '@appkit4/react-components';
import React from 'react';

interface PaginationProps {
    totalItems?: number;
    currentPage?: number;
    pageSize?: number;
    onPageChange?: (page: number) => void;
    onPageSizeChange?: (size: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    totalItems,
    currentPage,
    pageSize,
    onPageChange,
    onPageSizeChange,
}) => {
    const [internalCurrent, setInternalCurrent] = React.useState(1);
    const [internalPageSize, setInternalPageSize] = React.useState(25);

    const activePage = currentPage ?? internalCurrent;
    const activePageSize = pageSize ?? internalPageSize;
    const activeTotal = totalItems ?? 25 * 250;
    const totalPages = Math.ceil(activeTotal / activePageSize);

    const options = [
        { label: '10', value: '10' },
        { label: '25', value: '25' },
        { label: '100', value: '100' },
        { label: '250', value: '250' },
    ];

    return (
        <div className="pagination">
            <div className="ap-pagination-options-size-changer">
                <label
                    htmlFor="itemsPerPage"
                    className="ap-pagination-options-show"
                >
                    Show
                </label>
                <Select
                    className="ap-pagination-size-change compact"
                    defaultValue={String(activePageSize)}
                    data={options}
                    hideTitleOnInput
                    placeholder=""
                    onSelect={(selectedValue) => {
                        let value;
                        if (Array.isArray(selectedValue)) {
                            value = selectedValue[0];
                        } else {
                            value = selectedValue;
                        }
                        const numericValue =
                            typeof value === 'string' ? parseInt(value) : value;
                        if (onPageSizeChange) {
                            onPageSizeChange(numericValue);
                        } else {
                            setInternalPageSize(numericValue);
                            setInternalCurrent(1);
                        }
                    }}
                ></Select>
                <span className="ap-pagination-options-items">
                    Items / Page
                </span>
            </div>
            <CustomPagination
                current={activePage}
                total={totalPages}
                toPreviousPage={'Previous'}
                toNextPage={'Next'}
                onPageChange={(page) => {
                    if (onPageChange) {
                        onPageChange(page);
                    } else {
                        setInternalCurrent(page);
                    }
                }}
            ></CustomPagination>
        </div>
    );
};

export default Pagination;
